module.exports = __webpack_public_path__ + "media/customizations/carolinaorchards/logo-523a01dd83096201991f08888d6c1261.png";